module.exports = __webpack_public_path__ + "img/1_C.07285016.webp";